export default __webpack_public_path__ + "static/media/Client Logos – 08 – YPC Technologies.0f0716af.svg";